import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';

import styles from './TemplateStoryError.less';

// eslint-disable-next-line @trello/assets-alongside-implementation
import errorPagePng from 'resources/images/templates/error-page.png';

interface TemplateStoryErrorProps {
  onMount: () => void;
}

export const TemplateStoryError = ({ onMount }: TemplateStoryErrorProps) => {
  useEffect(() => {
    onMount();
  });

  return (
    <div className={styles.TemplateStoryErrorContainer}>
      <img
        alt=""
        role="presentation"
        className={styles.errorPageImage}
        src={errorPagePng}
      />
      <div className={styles.errorMessageContainer}>
        <p className={styles.errorMessage}>
          <FormattedMessage
            id="templates.templates.we-couldnt-find-that-template"
            defaultMessage="We couldn't find that template."
            description="The message displayed when a template is not found."
          />
        </p>
        <p className={styles.errorMessage}>
          <FormattedMessage
            id="templates.templates.were-sure-to-have-something-for-you-in-our-template-gallery"
            defaultMessage="We're sure to have something that's perfect for you in our template gallery."
            description="The message displayed to suggest that the user may find a suitable template in the template gallery."
          />
        </p>
      </div>
      <Button appearance="primary" href={'/templates'}>
        <FormattedMessage
          id="templates.templates.explore-template-gallery"
          defaultMessage="Explore template gallery"
          description="The text of the button that links to the template gallery."
        />
      </Button>
    </div>
  );
};
